import React from 'react'
import {
    Modal,
    Progress
} from 'antd'
import PropTypes from 'prop-types'

const ProgressModal = ({
    showModal,
    setShowModal,
    progressState,
    setProgressState
}) => {

    return (
        <Modal
            style={{ top: 20 }}
            closable={progressState.status.includes('success') || progressState.status.includes('exception')}
            visible={showModal}
            onOk={() => { }}
            onCancel={() => { setShowModal(false) }}
            afterClose={() => { setProgressState({ ...progressState, status: 'active', message: '', progress: 0 }) }}
            footer={null}
        >
            {progressState.message || ''}
            <Progress percent={progressState.progress} status={progressState.status || 'active'} />

        </Modal>
    )
}

ProgressModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    progressState: PropTypes.shape({
        status: PropTypes.string,
        progress: PropTypes.number.isRequired,
        message: PropTypes.string
    }).isRequired,
    setProgressState: PropTypes.func.isRequired
}
ProgressModal.defaultProps = {
    showModal: false,
    progressState: { status: 'active', progress: 0, message: '' }
}


export default ProgressModal